//Include Both Helper File with needed methods
import {
  getFirebaseBackend,
  editProfileDetails,
  changeUserEmail,
  changeUserPassword,
  getFirebaseAuthToken,
} from "../../../helpers/firebase_helper";
import {
  postFakeProfile,
  postJwtProfile,
} from "../../../helpers/fakebackend_helper";

// action
import {
  profileSuccess,
  profileError,
  resetProfileFlagChange,
} from "./reducer";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const fireBaseBackend = getFirebaseBackend();

export const editProfile = (user) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      response = fireBaseBackend.editProfileAPI(user.username, user.idx);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtProfile({
        username: user.username,
        idx: user.idx,
      });
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      response = postFakeProfile(user);
    }

    const data = await response;

    if (data) {
      dispatch(profileSuccess(data));
    }
  } catch (error) {
    dispatch(profileError(error));
  }
};

export const resetProfileFlag = () => {
  try {
    const response = resetProfileFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const editDetailsProfile = (userDetails) => async (dispatch) => {
  const token = await getFirebaseAuthToken();
  try {
    const response = await fetch(`${API_BASE}/dashboard/auth/profile`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify(userDetails),
    });
    const data = await response.json();
    dispatch(profileSuccess({ status: "success", data }));
    return data;
  } catch (error) {
    dispatch(profileError(error));
    return false;
  }
};

export const changeEmail = (newEmail, password) => async (dispatch) => {
  const token = await getFirebaseAuthToken();
  try {
    const response = await fetch(`${API_BASE}/dashboard/auth/email`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        newEmail,
        password,
        idToken: token,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      // Return error with specific message from backend
      return {
        error: true,
        message: data.message || data.error || "Unable to process email change request. Please try again later.",
      };
    }

    dispatch(profileSuccess({ status: "success", data: { email: newEmail } }));
    return { success: true, message: data.message || "Verification email sent successfully" };
  } catch (error) {
    console.error("Error changing email:", error);
    dispatch(profileError(error));
    return {
      error: true,
      message: "An unexpected error occurred. Please check your connection and try again.",
    };
  }
};

export const changePassword =
  (newPassword, currentPassword) => async (dispatch) => {
    try {
      const success = await changeUserPassword(newPassword, currentPassword);
      if (success) {
        dispatch(profileSuccess({ status: "success" }));
        return true;
      }
    } catch (error) {
      dispatch(profileError(error));
      return false;
    }
  };


export const getSignedUserAgreements = () => async (dispatch) => {
  const token = await getFirebaseAuthToken();
  try {
    const response = await fetch(`${API_BASE}/dashboard/agreements/signed`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
}


export const downloadSignedAgreementById = (agreementId) => async (dispatch) => {
  const token = await getFirebaseAuthToken();
  try {
    const response = await fetch(`${API_BASE}/dashboard/agreements/${agreementId}/download`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error fetching agreement");
    }

    return response;
  } catch (error) {
    return error;
  }
}